import { render, staticRenderFns } from "./HistoricConsumptionOrders.vue?vue&type=template&id=4b96c6e0"
import script from "./HistoricConsumptionOrders.vue?vue&type=script&lang=js"
export * from "./HistoricConsumptionOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports